export default __webpack_public_path__ + "static/media/watch_video_app_page.efbd8bb1.png";